const params = () => {

    const urlParams = new URLSearchParams(window.location.search);

    let acceptedParams = {
        chead: 0,
        cheadKey: '',
        nosnd: '',
        cheadTest: 0,
        gender: '',
        localTest: ''
    }

    urlParams.forEach((value, key) => {
        if (key in acceptedParams) {
            acceptedParams[key] = (key === 'cheadTest' || key === 'nosnd' || key === 'chead') ? parseInt(value) : value;
        }
    });

    return acceptedParams;

}

export default params;